import axios from "axios";
import { getHeaders, URL } from "./config";
export const trackUpsShipmentApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/trackUpsShipment`;
  axios
    .post(url, { trackingNumber: data }, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
};
export const trackFedexShipmentApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/trackFedexShipment`;
  axios
    .post(url, { trackingNumber: data }, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
};
export const trackUspsShipmentApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/trackUspsShipment`;
  axios
    .post(url, { trackingNumber: data }, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
export const refreshTracking = async (trackingId, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/refreshTracking`;
  axios
    .post(url, { trackingId: trackingId }, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
export const triggerUpdateAllTrackings = async (callback) => {
  const headers = await getHeaders();
  const url = `${URL}/triggerUpdateAllTrackings`;
  axios
    .post(url, {}, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
export const updateTrackingStatusApi = async (data, callback) => {
  const headers = await getHeaders();
  const url = `${URL}/updateTrackingStatus`;
  axios
    .post(url, data, { headers: headers })
    .then(async (response) => {
      if (response?.data) {
        callback({ status: 200, data: response?.data });
      }
    })
    .catch((error) => {
      callback({ status: 400, message: error?.message });
    });
}
